var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Something went wrong, we can not sign you in")])}
var staticRenderFns = []

export { render, staticRenderFns }